
const textBoldMaker = (text) => {
    const parts = text?.split('*');
    let processedText = '';
  
    for (let i = 0; i < parts?.length; i++) {
      processedText += parts[i];
      if (i < parts.length - 1) {
        processedText += `<span class="bold">${parts[i + 1]}</span>`;
        i++; // İkinci yıldızı atlamak için
      }
    }
    return processedText;
}

const textBoldMakerDouble = (text) => {
  const parts = text?.split('**');
  let processedText = '';

  for (let i = 0; i < parts?.length; i++) {
    processedText += parts[i];
    if (i < parts.length - 1) {
      processedText += `<span class="bold">${parts[i + 1]}</span>`;
      i++; // İkinci yıldızı atlamak için
    }
  }

  return processedText;
}

export {textBoldMakerDouble}
export default textBoldMaker
